import commonStyles from '../components/common.styles.scss';

export const isBackgroundOrange = () => {
  return document.body?.classList.contains(commonStyles.bodyBackground);
};
